export type Columns = 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type Rows = 1 | 2 | 3 | 4 | 5;

export const getColSpan = (cols: Columns): string =>
  ({
    3: 'lg:col-span-3',
    4: 'lg:col-span-4',
    5: 'lg:col-span-5',
    6: 'lg:col-span-6',
    7: 'lg:col-span-7',
    8: 'lg:col-span-8',
    9: 'lg:col-span-9',
    10: 'lg:col-span-10',
    11: 'lg:col-span-11',
    12: 'lg:col-span-12',
  })[cols];

export const getRowSpan = (rows: Rows): string =>
  ({
    1: 'row-span-1',
    2: 'row-span-2',
    3: 'row-span-3',
    4: 'row-span-4',
    5: 'row-span-5',
  })[rows];
